import moment from 'moment';

class DatabaseHeader {
  text: string;
  value: string;
  class?: string;
  unit?: string;
}

function exportToCSV(name: string, headers: DatabaseHeader[], values) {
  let csvString = '';
  let newLine = '\n';
  if (window.navigator.platform.indexOf('Win') !== -1)
    newLine = '\r' + newLine;

  let lastHeader = headers[headers.length - 1];
  for (const header of headers) {
    csvString += `${header.text}`;

    if (header.unit)
      csvString += ` (${header.unit})`;

    if (header.value != lastHeader.value)
      csvString += ',';
  }

  csvString += newLine;

  for (const paper of values) {
    for (const header of headers) {
      csvString += `${paper[header.value]}`;

      if (header.value != lastHeader.value)
        csvString += ',';
    }
    csvString += newLine;
  }

  const csvArray = new Array();
  csvArray[0] = csvString;
  const blob = new Blob(csvArray, { type: 'application/csv;charset=utf-8' });
  const blobURL = URL.createObjectURL(blob);
  const currentDate = moment(new Date()).format('YYYY-MM-DD_HHmm');

  const element = document.createElement('a');
  element.style.cssText = 'display: none';
  element.href = blobURL;
  element.setAttribute('download', `${name}-${currentDate}.csv`);
  document.body.appendChild(element);

  setTimeout(function () {
    element.click();
    element.remove();
  }, 100);

  setTimeout(function () {
    URL.revokeObjectURL(blobURL);
  }, 2000);
}

export { exportToCSV, DatabaseHeader };



// WEBPACK FOOTER //
// ./src/components/admin/tables/database.ts